const priceFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** Format a USD price, e.g. `1299` → `"$1,299.00"`. Shared across the product catalog. */
export function formatPrice(value: number): string {
  return priceFormatter.format(value);
}

/** Format a duration in months as whole years when divisible, else months
 *  (e.g. `24` → `"2 Years"`, `6` → `"6 Months"`). */
export function formatWarranty(months: number): string {
  if (months % 12 === 0) {
    const years = months / 12;
    return `${years} Year${years === 1 ? '' : 's'}`;
  }
  return `${months} Month${months === 1 ? '' : 's'}`;
}
